"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessage = void 0;
exports.defaultMessage = "No records in our system.";
//# sourceMappingURL=defaultMessage.js.map